var map = {
	"./delay_0.svg": "55f8",
	"./delay_1.svg": "3da3",
	"./delay_2.svg": "8186",
	"./delay_3.svg": "0fbe",
	"./delay_4.svg": "49cb",
	"./delay_5.svg": "da37",
	"./delay_6.svg": "eecc",
	"./delay_7.svg": "5c58",
	"./delay_8.svg": "b96c",
	"./delay_9.svg": "f3d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2882";